<div class="flex w-full h-full bg-[#1a1a1a] overflow-hidden">

  <!-- Overlay mobile (fecha sidebar ao clicar fora) -->
  @if (sidebarAberta()) {
    <div class="fixed inset-0 bg-black/60 z-30 md:hidden" (click)="fecharSidebar()"></div>
  }

  <!-- Sidebar -->
  <aside class="flex flex-col bg-[#232323] border-r border-zinc-800 z-40
                fixed inset-y-0 left-0 w-72 transition-transform duration-300 ease-in-out
                md:relative md:translate-x-0 md:flex"
         [class.-translate-x-full]="!sidebarAberta()"
         [class.translate-x-0]="sidebarAberta()">
    <!-- Header da Sidebar -->
    <div class="p-4 border-b border-zinc-800">
      <div class="flex items-center gap-3 mb-4">
        <div class="w-10 h-10 bg-gradient-to-br from-amber-500 to-orange-600 rounded-xl flex items-center justify-center shadow-lg shadow-amber-500/20">
          <mat-icon svgIcon="chameleon" class="text-white icon-size-7"></mat-icon>
        </div>
        <div>
          <h1 class="text-lg font-bold text-white">EdducAI</h1>
          <p class="text-xs text-white/50">Assistente Inteligente</p>
        </div>
      </div>

      <!-- Novo Chat Button -->
      <button type="button" (click)="criarNovoChat()" 
              class="w-full flex items-center justify-center gap-2 px-4 py-3 bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 text-white font-semibold rounded-xl transition-all duration-200 shadow-lg shadow-amber-500/20 hover:shadow-amber-500/30">
        <mat-icon svgIcon="heroicons_outline:plus" class="icon-size-5"></mat-icon>
        <span>Novo Chat</span>
      </button>
    </div>

    <!-- Nova Pasta Accordion -->
    <div class="px-3 pt-3">
      <mat-accordion class="custom-accordion">
        <mat-expansion-panel class="!bg-zinc-800/50 !rounded-xl !shadow-none">
          <mat-expansion-panel-header class="!bg-transparent">
            <mat-panel-title class="flex items-center text-white/70 text-sm">
              <mat-icon svgIcon="heroicons_outline:folder-plus" class="icon-size-5 mr-2"></mat-icon>
              <span>Nova Pasta</span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <form [formGroup]="pastaForm" (ngSubmit)="criarNovaPasta()" class="p-2">
            <input
              formControlName="nome"
              type="text"
              placeholder="Nome da pasta..."
              class="w-full px-3 py-2.5 mb-3 text-white text-sm placeholder-white/70 bg-zinc-900 rounded-lg border border-zinc-700 focus:border-amber-500 focus:ring-1 focus:ring-amber-500 outline-none transition-all"
              [class.border-red-400]="pastaForm.controls['nome'].invalid && pastaForm.controls['nome'].touched" />
            <button
              mat-flat-button
              type="submit"
              [disabled]="pastaForm.invalid"
              class="w-full !bg-zinc-700 hover:!bg-zinc-600 !text-white !rounded-lg !py-2 disabled:opacity-50">
              <span class="flex items-center justify-center gap-2">
                <mat-icon svgIcon="heroicons_outline:plus" class="icon-size-4"></mat-icon>
                Criar
              </span>
            </button>
          </form>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <!-- Pastas Section -->
    <div class="mt-4 px-3">
      <div class="flex items-center justify-between px-2 mb-2">
        <span class="text-xs text-white/40 uppercase tracking-wider font-semibold">Pastas</span>
        <span class="text-xs text-white/30">{{ pastas?.length || 0 }}</span>
      </div>

      <div class="space-y-1 max-h-[25vh] overflow-y-auto scrollbar-thin">
        @for (pasta of pastas; track trackById) {
          <div class="group">
            <button (click)="selecionaPasta(pasta)" 
                    class="w-full flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm transition-all duration-150"
                    [ngClass]="pasta === pastaSelecionada 
                      ? 'bg-amber-500/20 text-amber-400 border border-amber-500/30' 
                      : 'text-white/70 hover:bg-zinc-800 hover:text-white'">
              <mat-icon svgIcon="heroicons_outline:folder" class="icon-size-5 flex-shrink-0"></mat-icon>
              <span class="truncate flex-1 text-left font-medium">{{ pasta.nome }}</span>
              <div class="flex items-center gap-0.5 opacity-0 group-hover:opacity-100 transition-opacity">
                <button type="button" tabindex="-1" class="p-1 hover:bg-white/10 rounded"
                        (click)="alternarVisibilidadePasta(pasta); $event.stopPropagation();">
                  <mat-icon [svgIcon]="pasta.id === pastaExpandidaId ? 'heroicons_outline:chevron-up' : 'heroicons_outline:chevron-down'"
                            class="icon-size-4"></mat-icon>
                </button>
                <button type="button" tabindex="-1" class="p-1 hover:bg-white/10 rounded"
                        [matMenuTriggerFor]="pastaMenu"
                        (click)="menuPastaAtiva = pasta; $event.stopPropagation();">
                  <mat-icon svgIcon="heroicons_outline:ellipsis-vertical" class="icon-size-4"></mat-icon>
                </button>
              </div>
            </button>

            @if (pasta.id === pastaExpandidaId && chatsPorPasta[pasta.id]?.length) {
              <div class="ml-4 mt-1 space-y-1 border-l-2 border-zinc-700 pl-3">
                @for (chat of (chatsPorPasta[pasta.id] || []); track trackById) {
                  <button (click)="selecionarChatDaPasta(chat)" 
                          class="w-full flex items-center gap-2 px-2 py-2 rounded-lg text-xs transition-all duration-150 group/chat"
                          [ngClass]="chat === chatSelecionado 
                            ? 'bg-amber-500/15 text-amber-400' 
                            : 'text-white/60 hover:bg-zinc-800 hover:text-white'">
                    <mat-icon svgIcon="heroicons_outline:chat-bubble-oval-left-ellipsis" class="icon-size-4"></mat-icon>
                    <span class="truncate flex-1 text-left">{{ chat.nome || 'Chat' }}</span>
                    <button type="button" tabindex="-1"
                            class="p-1 hover:bg-white/10 rounded opacity-0 group-hover/chat:opacity-100 transition-opacity"
                            [matMenuTriggerFor]="chatMenu"
                            (click)="menuChatAtivo = chat; $event.stopPropagation();">
                      <mat-icon svgIcon="heroicons_outline:ellipsis-vertical" class="icon-size-4"></mat-icon>
                    </button>
                  </button>
                }
              </div>
            }
          </div>
        }
        @if (pastas.length === 0) {
          <div class="px-3 py-4 text-center text-white/30 text-xs">Nenhuma pasta criada</div>
        }
      </div>
    </div>

    <!-- Menus -->
    <mat-menu #pastaMenu="matMenu">
      <button mat-menu-item (click)="renomearPastaDialog(menuPastaAtiva!)">
        <mat-icon svgIcon="heroicons_outline:pencil"></mat-icon>
        <span>Renomear</span>
      </button>
      <button mat-menu-item (click)="excluirPasta(menuPastaAtiva!.id)">
        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
        <span>Excluir</span>
      </button>
    </mat-menu>

    <mat-menu #chatMenu="matMenu">
      <button mat-menu-item (click)="renomearChatDialog(menuChatAtivo!)">
        <mat-icon svgIcon="heroicons_outline:pencil"></mat-icon>
        <span>Renomear</span>
      </button>
      <button mat-menu-item (click)="excluirChat(menuChatAtivo!.id)">
        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
        <span>Excluir</span>
      </button>
      <button mat-menu-item [matMenuTriggerFor]="moverParaPastaMenu">
        <mat-icon svgIcon="heroicons_outline:folder-arrow-down"></mat-icon>
        <span>Mover para pasta</span>
      </button>
    </mat-menu>

    <mat-menu #moverParaPastaMenu="matMenu">
      <button *ngFor="let pasta of pastasParaMover; trackBy: trackById" mat-menu-item
              (click)="moverChatParaOutraPasta(menuChatAtivo?.id!, pasta.id)">
        <mat-icon svgIcon="heroicons_outline:folder" class="mr-2"></mat-icon>
        <span>{{ pasta.nome }}</span>
      </button>
      <button *ngIf="!chatSemPasta" mat-menu-item (click)="moverChatParaOutraPasta(menuChatAtivo?.id!, null)">
        <mat-icon svgIcon="heroicons_outline:minus-circle" class="mr-2"></mat-icon>
        <span>Remover de pasta</span>
      </button>
    </mat-menu>

    <div class="h-px bg-zinc-800 mx-3 my-3"></div>

    <!-- Chats sem pasta -->
    <!-- Chats sem pasta -->
    <div class="flex-1 flex flex-col min-h-0 px-3">
      <div class="flex items-center justify-between px-2 mb-2">
        <span class="text-xs text-white/40 uppercase tracking-wider font-semibold">Histórico</span>
        <span class="text-xs text-white/30">{{ chatsSemPasta?.length || 0 }}</span>
      </div>
      
      <div class="flex-1 overflow-y-auto space-y-1 scrollbar-thin pb-4">
        @for (chat of chatsSemPasta; track trackById) {
          <button (click)="selecionarChatSemPasta(chat)" 
                  class="w-full flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm transition-all duration-150 group"
                  [ngClass]="chat === chatSelecionado 
                    ? 'bg-amber-500/20 text-amber-400 border border-amber-500/30' 
                    : 'text-white/70 hover:bg-zinc-800 hover:text-white'">
            <mat-icon svgIcon="heroicons_outline:chat-bubble-oval-left-ellipsis" class="icon-size-5 flex-shrink-0"></mat-icon>
            <span class="truncate flex-1 text-left">{{ chat.nome || 'Novo Chat' }}</span>
            <button type="button" tabindex="-1"
                    class="p-1 hover:bg-white/10 rounded opacity-0 group-hover:opacity-100 transition-opacity"
                    [matMenuTriggerFor]="chatMenuSemPasta"
                    (click)="menuChatAtivo = chat; $event.stopPropagation();">
              <mat-icon svgIcon="heroicons_outline:ellipsis-vertical" class="icon-size-4"></mat-icon>
            </button>
          </button>
        }
        @if (chatsSemPasta.length === 0) {
          <div class="px-3 py-4 text-center text-white/30 text-xs">Nenhum chat no histórico</div>
        }
      </div>
    </div>

    <mat-menu #chatMenuSemPasta="matMenu">
      <button mat-menu-item (click)="renomearChatDialog(menuChatAtivo!)">
        <mat-icon svgIcon="heroicons_outline:pencil"></mat-icon>
        <span>Renomear</span>
      </button>
      <button mat-menu-item (click)="excluirChat(menuChatAtivo!.id)">
        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
        <span>Excluir</span>
      </button>
      <button mat-menu-item [matMenuTriggerFor]="moverParaPastaMenu">
        <mat-icon svgIcon="heroicons_outline:folder-arrow-down"></mat-icon>
        <span>Mover para pasta</span>
      </button>
    </mat-menu>
  </aside>

  <!-- Main Chat Area -->
  <main class="flex-1 min-h-0 flex flex-col bg-[#1a1a1a] overflow-hidden min-w-0">
    <!-- Header do Chat -->
    <header class="flex items-center justify-between px-4 md:px-6 py-4 border-b border-zinc-800 bg-[#232323]">
      <div class="flex items-center gap-3">
        <!-- Botão hambúrguer (apenas mobile) -->
        <button class="md:hidden p-1.5 text-white/70 hover:text-white hover:bg-zinc-700 rounded-lg transition-all"
                (click)="toggleSidebar()" aria-label="Abrir menu">
          <mat-icon svgIcon="heroicons_outline:bars-3" class="icon-size-6"></mat-icon>
        </button>

        <div class="w-9 h-9 bg-gradient-to-br from-amber-500 to-orange-600 rounded-lg flex items-center justify-center flex-shrink-0">
          <mat-icon svgIcon="chameleon" class="text-white icon-size-6"></mat-icon>
        </div>
        <div class="min-w-0">
          <h2 class="text-base font-semibold text-white truncate max-w-[160px] sm:max-w-none">{{ tituloHeader }}</h2>
          @if (agenteSelecionado) {
            <p class="text-xs text-white/50 flex items-center gap-1">
              <mat-icon class="material-symbols-outlined text-amber-500 text-xs">psychology</mat-icon>
              <span class="truncate">{{ subtituloAgente }}</span>
            </p>
          }
        </div>
      </div>
      
      <div class="flex items-center gap-2">
        @if (agenteSelecionado) {
          <div class="flex items-center gap-2 px-3 py-1.5 bg-zinc-800 rounded-full">
            <span class="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
            <span class="text-xs text-white/60">Online</span>
          </div>
        }
      </div>
    </header>

    <!-- Messages Area -->
    <div class="flex-1 min-h-0 overflow-hidden flex flex-col">
      <div #msgsContainer class="flex-1 min-h-0 overflow-y-auto px-3 md:px-6 py-4 md:py-6 space-y-4 scroll-smooth">
        @if (mensagensChatSelecionado?.length > 0) {
          @for (msg of mensagensChatSelecionado; track trackById) {
            <!-- User Message -->
            @if (msg.statusMensagemIAId === 1) {
              <div class="flex justify-end">
                <div class="max-w-[70%] flex items-end gap-2">
                  <div class="px-4 py-3 rounded-2xl rounded-br-md bg-gradient-to-br from-amber-500 to-orange-600 text-white text-sm shadow-lg whitespace-pre-wrap break-words">
                    {{ msg.texto }}
                  </div>
                  <div class="w-8 h-8 rounded-full bg-zinc-700 flex items-center justify-center flex-shrink-0">
                    <mat-icon svgIcon="heroicons_solid:user" class="text-white/70 icon-size-5"></mat-icon>
                  </div>
                </div>
              </div>
            }
            <!-- AI Response -->
            @if (msg.statusMensagemIAId === 2) {
              <div class="flex justify-start">
                <div class="max-w-[85%] md:max-w-[70%] flex items-end gap-2">
                  <div class="w-8 h-8 rounded-full bg-gradient-to-br from-amber-500 to-orange-600 flex items-center justify-center flex-shrink-0 shadow-lg shadow-amber-500/20">
                    <mat-icon svgIcon="chameleon" class="text-white icon-size-5"></mat-icon>
                  </div>
                  <div class="ai-message px-4 py-3 rounded-2xl rounded-bl-md bg-zinc-800 text-white text-sm shadow-lg break-words border border-zinc-700"
                       [innerHTML]="msg.texto | markdown">
                  </div>
                </div>
              </div>
            }
            <!-- Warning/Info -->
            @if (msg.statusMensagemIAId === 3) {
              <div class="flex justify-center">
                <div class="px-4 py-2 rounded-full bg-amber-500/20 text-amber-400 text-xs font-medium border border-amber-500/30">
                  {{ msg.texto }}
                </div>
              </div>
            }
            <!-- Error -->
            @if (msg.statusMensagemIAId === 4 || msg.statusMensagemIAId === 5) {
              <div class="flex justify-center">
                <div class="px-4 py-2 rounded-full bg-red-500/20 text-red-400 text-xs font-medium border border-red-500/30">
                  {{ msg.texto }}
                </div>
              </div>
            }
          }
        } @else {
          <!-- Empty State -->
          <div class="h-full flex flex-col items-center justify-center text-center">
            <div class="w-24 h-24 bg-gradient-to-br from-amber-500/20 to-orange-600/20 rounded-2xl flex items-center justify-center mb-6">
              <mat-icon svgIcon="chameleon" class="text-amber-500 icon-size-16"></mat-icon>
            </div>
            <h3 class="text-xl font-semibold text-white mb-2">Olá! Sou o EdducAI</h3>
            <p class="text-white/50 text-sm max-w-md mb-6">
              Seu assistente inteligente para dúvidas sobre o mercado imobiliário, 
              documentação, legislação e muito mais.
            </p>
            <div class="flex flex-wrap gap-2 justify-center max-w-lg">
              <button class="px-4 py-2 bg-zinc-800 hover:bg-zinc-700 text-white/70 hover:text-white text-xs rounded-full border border-zinc-700 transition-all">
                � Dicas para corretores iniciantes
              </button>
              <button class="px-4 py-2 bg-zinc-800 hover:bg-zinc-700 text-white/70 hover:text-white text-xs rounded-full border border-zinc-700 transition-all">
                🏠 Tendências do mercado imobiliário
              </button>
              <button class="px-4 py-2 bg-zinc-800 hover:bg-zinc-700 text-white/70 hover:text-white text-xs rounded-full border border-zinc-700 transition-all">
                📋 Documentação para venda de imóvel
              </button>
            </div>
          </div>
        }

        <!-- Thinking Indicator -->
        @if (isThinkingIA) {
          <div class="flex justify-start">
            <div class="flex items-end gap-2">
              <div class="w-8 h-8 rounded-full bg-gradient-to-br from-amber-500 to-orange-600 flex items-center justify-center flex-shrink-0 shadow-lg shadow-amber-500/20">
                <mat-icon svgIcon="chameleon" class="text-white icon-size-5"></mat-icon>
              </div>
              <div class="px-4 py-3 rounded-2xl rounded-bl-md bg-zinc-800 border border-amber-500/20 shadow-lg">
                <div class="flex items-center gap-2">
                  <span class="text-white/70 text-sm font-medium">Pensando</span>
                  <span class="typing"><span></span></span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>

      <!-- Input Area -->
      <div class="px-3 md:px-6 py-3 md:py-4 border-t border-zinc-800 bg-[#232323]">
        <form [formGroup]="mensagemForm" (ngSubmit)="enviarMensagemUsuario()" class="relative" autocomplete="off">
          <div class="flex items-end gap-3 bg-zinc-800 rounded-2xl p-2 border border-zinc-700 focus-within:border-amber-500/50 transition-all">
            <textarea
              formControlName="texto"
              [disabled]="isSending"
              (keydown.enter)="onEnterMensagem($event)"
              [placeholder]="placeholderMensagem"
              class="flex-1 bg-transparent text-white text-sm placeholder-white/40 px-3 py-2 resize-none outline-none min-h-[44px] max-h-[120px] scrollbar-thin"
              autocomplete="off"
              rows="1">
            </textarea>
            
            <div class="flex items-center gap-1 pb-1">
              <button type="button"
                      [matMenuTriggerFor]="acoesMenu"
                      class="p-2 text-white/50 hover:text-white hover:bg-zinc-700 rounded-lg transition-all"
                      aria-label="Mais ações">
                <mat-icon svgIcon="heroicons_outline:ellipsis-horizontal" class="icon-size-5"></mat-icon>
              </button>
              
              <button type="submit"
                      [disabled]="mensagemForm.invalid || isThinkingIA"
                      class="p-2.5 bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 disabled:from-zinc-600 disabled:to-zinc-600 disabled:cursor-not-allowed text-white rounded-xl transition-all shadow-lg shadow-amber-500/20 disabled:shadow-none">
                <mat-icon svgIcon="heroicons_solid:paper-airplane" class="icon-size-5"></mat-icon>
              </button>
            </div>
          </div>
          
          <p class="text-center text-white/30 text-[10px] mt-2">
            EdducAI pode cometer erros. Verifique informações importantes.
          </p>
        </form>
        
        <mat-menu #acoesMenu="matMenu">
          <button mat-menu-item (click)="surpreender()" [disabled]="isThinkingIA || !agenteSelecionado">
            <mat-icon svgIcon="heroicons_outline:sparkles" class="text-amber-500"></mat-icon>
            <span>Surpreenda-me</span>
          </button>
          <button mat-menu-item (click)="enviarArquivo()">
            <mat-icon svgIcon="heroicons_outline:paper-clip"></mat-icon>
            <span>Enviar Arquivo</span>
          </button>
          <button mat-menu-item (click)="abrirMenuPersonasDelay()">
            <mat-icon svgIcon="heroicons_outline:user-group"></mat-icon>
            <span>Selecionar Persona</span>
          </button>
        </mat-menu>

        <!-- Personas Menu -->
        @if (personasMenuAberto()) {
          <div class="absolute right-2 md:right-6 bottom-24 w-[calc(100vw-1rem)] max-w-[288px] max-h-[60vh] overflow-y-auto bg-zinc-900 shadow-2xl rounded-2xl border border-zinc-700 z-50">
            <div class="p-4 border-b border-zinc-800">
              <h4 class="text-sm font-semibold text-white flex items-center gap-2">
                <mat-icon class="material-symbols-outlined text-amber-500 text-lg">psychology</mat-icon>
                Escolha um Agente
              </h4>
            </div>
            <div class="p-2">
              @if (agentesIA?.length > 0) {
                @for (agente of agentesIA; track trackById) {
                  <button class="w-full text-left px-4 py-3 rounded-xl text-sm font-medium text-white/70 hover:bg-amber-500/10 hover:text-amber-400 transition-all"
                          (click)="selecionarAgente(agente)">
                    <div class="flex items-center gap-3">
                      <div class="w-8 h-8 bg-zinc-800 rounded-lg flex items-center justify-center">
                        <mat-icon svgIcon="chameleon" class="text-amber-500 icon-size-5"></mat-icon>
                      </div>
                      <span>{{ agente.nome }}</span>
                    </div>
                  </button>
                }
              } @else {
                <div class="px-4 py-6 text-center text-white/40 text-sm">Nenhum agente disponível</div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </main>
</div>
